import Vue from "vue";
import Router from "vue-router";
import Expenses from "./views/Expenses";
import Overview from "./views/Overview";
import Export from "./views/Export";
import RapidEmail from "./views/RapidEmail";
import Team from "./views/Team";
import Setting from "./views/Setting";
import Signin from "./views/auth/Signin";
import Signup from "./views/auth/Signup";
import confirmSignup from "./views/auth/confirmSignup";
import Forgot from "./views/auth/Forgot";
import Reset from "./views/auth/Reset";
import Landing from "./views/Landing";
import Privacy from "./views/privacyterms/Privacy";
import Terms from "./views/privacyterms/Terms";
import { getUserId } from "./utils/auth";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "landing",
			components: {
				default: Landing
			}
		},
		{
			path: "/expenses",
			name: "expenses",
			components: {
				default: Expenses
			},
			meta: { requiresAuth: true }
		},
		{
			path: "/overview",
			name: "overview",
			components: {
				default: Overview
			},
			meta: { requiresAuth: true }
		},
		{
			path: "/export",
			name: "export",
			components: {
				default: Export
			},
			meta: { requiresAuth: true }
		},
		{
			path: "/rapid-email",
			name: "rapidemail",
			components: {
				default: RapidEmail
			},
			meta: { requiresAuth: true }
		},
		{
			path: "/team",
			name: "team",
			components: {
				default: Team
			},
			meta: { requiresAuth: true }
		},
		{
			path: "/setting",
			name: "setting",
			components: {
				default: Setting
			},
			meta: { requiresAuth: true }
		},
		{
			path: "/signin",
			name: "signin",
			components: {
				default: Signin
			}
		},
		{
			path: "/signup",
			name: "signup",
			components: {
				default: Signup
			}
		},
		{
			path: "/confirmsignup",
			name: "confirmsignup",
			components: {
				default: confirmSignup
			}
		},
		{
			path: "/forgot",
			name: "forgot",
			components: {
				default: Forgot
			}
		},
		{
			path: "/reset",
			name: "reset",
			components: {
				default: Reset
			}
		},
		{
			path: "/privacy",
			name: "privacy",
			components: {
				default: Privacy
			}
		},
		{
			path: "/terms",
			name: "terms",
			components: {
				default: Terms
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	const userId = getUserId();
	if (to.meta.requiresAuth) {
		if (userId) {
			next();
		} else {
			next({ name: "expenses" });
		}
	} else {
		if (userId) {
			if (
				to.path == "/" ||
				to.path == "/signin" ||
				to.path == "/signup" ||
				to.path == "/confirmsignup" ||
				to.path == "/forgot" ||
				to.path == "/reset"
			) {
				next({ name: "expenses" });
			} else {
				next();
			}
		} else {
			next();
		}
	}
});

export default router;
